"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = TableRow;
exports["default"] = Table;
exports.TableHeader = exports.sortDirection = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

var _TableCheckBox = _interopRequireDefault(require("../TableCheckBox/TableCheckBox"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var StyledTable = _styledComponents["default"].table.withConfig({
  displayName: "Table__StyledTable",
  componentId: "sc-70mzuy-0"
})(["border-spacing:0;width:100%;table-layout:", ";"], function (_ref) {
  var tableLayout = _ref.tableLayout;
  return tableLayout;
});

var StyledTableHeader = _styledComponents["default"].th.withConfig({
  displayName: "Table__StyledTableHeader",
  componentId: "sc-70mzuy-1"
})(function (_ref2) {
  var theme = _ref2.theme,
      sortColumns = _ref2.sortColumns,
      width = _ref2.width;
  return (0, _styledComponents.css)(["margin:0;padding:0 1rem;border-bottom:1px solid ", ";color:", ";font-size:", "rem;font-weight:", ";cursor:", ";outline:none;width:", ";"], theme.color.structure, theme.color.text, theme.font.size.caption, theme.font.weight.black, sortColumns ? 'pointer' : 'auto', width || 'auto');
});

var HeaderRow = _styledComponents["default"].tr.withConfig({
  displayName: "Table__HeaderRow",
  componentId: "sc-70mzuy-2"
})(["height:2rem;"]);

var StyledTableRow = _styledComponents["default"].tr.withConfig({
  displayName: "Table__StyledTableRow",
  componentId: "sc-70mzuy-3"
})(function (_ref3) {
  var selected = _ref3.selected,
      selectRows = _ref3.selectRows,
      disableSelect = _ref3.disableSelect,
      focused = _ref3.focused,
      theme = _ref3.theme;
  return (0, _styledComponents.css)(["height:4rem;transition:all 0.2s ease;", " ", " ", ""], selected && (0, _styledComponents.css)(["background:", ";"], theme.color.action), selectRows && !selected && !disableSelect && (0, _styledComponents.css)([":hover{background:", ";}"], theme.color.structure), focused && (0, _styledComponents.css)(["td:first-child{box-shadow:inset 0.25rem 0 0 0 ", ";}"], theme.color.focus));
});

var TableData = _styledComponents["default"].td.withConfig({
  displayName: "Table__TableData",
  componentId: "sc-70mzuy-4"
})(function (_ref4) {
  var selected = _ref4.selected,
      selectRowColumn = _ref4.selectRowColumn,
      theme = _ref4.theme;
  return (0, _styledComponents.css)(["border-bottom:1px solid ", ";padding:1rem;font-size:", "rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;", " ", ""], theme.color.structure, theme.font.size.body, selected ? (0, _styledComponents.css)(["color:", ";p,a,a:active,a:visited{color:", ";}"], theme.color.paper, theme.color.paper) : (0, _styledComponents.css)(["color:", ";a,a:active,a:visited{color:", ";}"], theme.color.text, theme.color.action), selectRowColumn && (0, _styledComponents.css)(["width:5.75rem;min-width:5.75rem;"]));
});

var HeaderContainer = _styledComponents["default"].span.withConfig({
  displayName: "Table__HeaderContainer",
  componentId: "sc-70mzuy-5"
})(["display:flex;justify-content:flex-start;flex-direction:row;flex-wrap:nowrap;align-items:center;"]);

var SelectHeaderContainer = (0, _styledComponents["default"])(HeaderContainer).withConfig({
  displayName: "Table__SelectHeaderContainer",
  componentId: "sc-70mzuy-6"
})(["color:", ";cursor:pointer;"], function (props) {
  return props.theme.color.action;
});

var IconContainer = _styledComponents["default"].span.withConfig({
  displayName: "Table__IconContainer",
  componentId: "sc-70mzuy-7"
})(["display:flex;justify-content:center;align-items:center;min-height:1rem;min-width:1rem;"]);

var sortDirection = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  NONE: 'none'
};
exports.sortDirection = sortDirection;

function getAriaSortDirection(accessor, headerSortObj) {
  var _Object$entries = Object.entries(headerSortObj),
      _Object$entries2 = _slicedToArray(_Object$entries, 2),
      headerSortAccessor = _Object$entries2[0],
      headerSortDirection = _Object$entries2[1];

  return headerSortAccessor === accessor ? headerSortDirection : sortDirection.NONE;
}

function getNextSortDirection(accessor) {
  var currentSortDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sortDirection.NONE;
  var defaultSort = arguments.length > 2 ? arguments[2] : undefined;

  switch (currentSortDirection) {
    case sortDirection.NONE:
      return sortDirection.ASCENDING;

    case sortDirection.ASCENDING:
      return sortDirection.DESCENDING;

    default:
      return currentSortDirection === defaultSort[accessor] ? sortDirection.ASCENDING : sortDirection.NONE;
  }
}

function getNextSortHeaderObj(accessor) {
  var currentSortDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sortDirection.NONE;
  var defaultSort = arguments.length > 2 ? arguments[2] : undefined;
  var nextSortDirection = getNextSortDirection(accessor, currentSortDirection, defaultSort);
  if (Object.keys(defaultSort).length && nextSortDirection === sortDirection.NONE) return defaultSort;
  return _defineProperty({}, accessor, nextSortDirection);
}

function SortDirectionIcon(_ref6) {
  var _ref6$columnSorted = _ref6.columnSorted,
      columnSorted = _ref6$columnSorted === void 0 ? null : _ref6$columnSorted;

  var theme = _react["default"].useContext(_styledComponents.ThemeContext);

  switch (columnSorted) {
    case sortDirection.DESCENDING:
      return /*#__PURE__*/_react["default"].createElement(_uiIcons.CaretDown, {
        size: 16,
        color: theme.color.action
      });

    case sortDirection.ASCENDING:
      return /*#__PURE__*/_react["default"].createElement(_uiIcons.CaretUp, {
        size: 16,
        color: theme.color.action
      });

    default:
      return null;
  }
}

var TableHeader = function TableHeader(_ref7) {
  var _ref7$columns = _ref7.columns,
      columns = _ref7$columns === void 0 ? [] : _ref7$columns,
      _ref7$sortColumns = _ref7.sortColumns,
      sortColumns = _ref7$sortColumns === void 0 ? false : _ref7$sortColumns,
      _ref7$sortOptions = _ref7.sortOptions,
      sortOptions = _ref7$sortOptions === void 0 ? {} : _ref7$sortOptions,
      _ref7$selectRows = _ref7.selectRows,
      selectRows = _ref7$selectRows === void 0 ? false : _ref7$selectRows,
      _ref7$selectHeaderLab = _ref7.selectHeaderLabel,
      selectHeaderLabel = _ref7$selectHeaderLab === void 0 ? '' : _ref7$selectHeaderLab,
      _ref7$onClick = _ref7.onClick,
      _onClick = _ref7$onClick === void 0 ? function () {} : _ref7$onClick,
      _ref7$onSelectHeaderC = _ref7.onSelectHeaderClick,
      onSelectHeaderClick = _ref7$onSelectHeaderC === void 0 ? function () {} : _ref7$onSelectHeaderC;

  return /*#__PURE__*/_react["default"].createElement(HeaderRow, null, columns.map(function (column) {
    return /*#__PURE__*/_react["default"].createElement(StyledTableHeader, {
      "aria-sort": getAriaSortDirection(column.accessor, sortOptions),
      scope: "col",
      role: "columnheader",
      key: "header-column-".concat(column.accessor),
      sortColumns: sortColumns && !column.disableSort,
      tabIndex: sortColumns ? '0' : '-1',
      width: column.width,
      onClick: function onClick() {
        return _onClick(column.accessor, sortColumns && !column.disableSort);
      }
    }, /*#__PURE__*/_react["default"].createElement(HeaderContainer, null, column.header, sortColumns && /*#__PURE__*/_react["default"].createElement(IconContainer, null, /*#__PURE__*/_react["default"].createElement(SortDirectionIcon, {
      columnSorted: sortOptions[column.accessor]
    }))));
  }), selectRows && /*#__PURE__*/_react["default"].createElement(StyledTableHeader, {
    sortColumns: sortColumns,
    onClick: onSelectHeaderClick
  }, /*#__PURE__*/_react["default"].createElement(SelectHeaderContainer, null, selectHeaderLabel)));
};

exports.TableHeader = TableHeader;

function TableRow(_ref8) {
  var _ref8$row = _ref8.row,
      row = _ref8$row === void 0 ? {} : _ref8$row,
      _ref8$columns = _ref8.columns,
      columns = _ref8$columns === void 0 ? [] : _ref8$columns,
      _ref8$selectRows = _ref8.selectRows,
      selectRows = _ref8$selectRows === void 0 ? false : _ref8$selectRows,
      _ref8$selected = _ref8.selected,
      selected = _ref8$selected === void 0 ? false : _ref8$selected,
      _ref8$onChange = _ref8.onChange,
      onChange = _ref8$onChange === void 0 ? function () {} : _ref8$onChange;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  function handleFocus() {
    setFocused(true);
  }

  function handleBlur() {
    setFocused(false);
  }

  return /*#__PURE__*/_react["default"].createElement(StyledTableRow, {
    focused: focused,
    selected: selected,
    disableSelect: row.disableSelect,
    selectRows: selectRows
  }, columns.map(function (column, index) {
    return /*#__PURE__*/_react["default"].createElement(TableData, {
      id: index === 0 ? "checkbox-".concat(row.id) : null,
      selected: selected,
      key: "cell-".concat(column.accessor)
    }, row[column.accessor]);
  }), selectRows && /*#__PURE__*/_react["default"].createElement(TableData, {
    selectRowColumn: true
  }, /*#__PURE__*/_react["default"].createElement(_TableCheckBox["default"], {
    id: "row-checkbox-".concat(row.id),
    name: "row-checkbox-".concat(row.id),
    value: "".concat(row.id),
    checked: selected,
    disabled: row.disableSelect,
    onChange: onChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    "aria-labelledby": "checkbox-".concat(row.id)
  })));
}

function findDefaultSort(columns) {
  var _column$sortDirection;

  var column = columns.find(function (column) {
    return Object.keys(column).includes('sortDirection');
  });
  return Object.values(sortDirection).includes(column === null || column === void 0 ? void 0 : (_column$sortDirection = column.sortDirection) === null || _column$sortDirection === void 0 ? void 0 : _column$sortDirection.toLowerCase()) ? _defineProperty({}, column.accessor, column.sortDirection) : {};
}
/**
 *
 * #### Styled table component

The **Table** component is a standard html table. It's data is rendered by suppling an array of row objects to the `rowData` prop. The format is shown below:

```
[
  {
    id: '123-456-ABC',
    accessorName1: 'value0',
    accessorName2: 'another value0',
  },
  {
    id: '789-012-DEF',
    accessorName1: 'value1',
    accessorName2: 'another value1',
  }
 ]
```

Each row object lists the column values using a key/value pair. The key being the column accessor along with the value to be rendered in the table cell. Please note that each row is required to have an unique `id` string property. The column key should correspond to one of the objects defined in the `columns` prop array. The format is shown below:

```
[
  {
    header: 'Column header title',
    accessor: 'accessorName1',
    width: '10rem',
    disableSort: true,
  },
  {
    header: 'Another column header title',
    accessor: 'accessorName2',
    width: '20%',
    sortDirection: 'ascending',
  }
]
```

So in this way, the `columns` array defines the columns and then the `rowdata` defines the rows. The component assigns each data point to a column using the accessor. Each column object requires the `header` and `accessor` properties. The other props shown in the above example are optional and can be defined as required per each column; `width`, `sortDirection` and `disableSort`.

- `width`: Can be passed with any valid CSS width value. This provides the total width of every column is not greater than `calc(100% - 5.75rem)`. If none is given then the columns width will be set to `auto`.
- `sortDirection`: The default sortDirection for the column. Can be either `ascending | descending | none`.
- `disableSort`: You are able to disable sorting on individual columns by setting the `disableSort` prop to true.

The **Table** also allows for sorting. To apply sorting, set the `sortColumns` prop to `true`. This will enable to rendering of the up/down caret icon when a header is clicked. A function that is passed to the `onHeaderClick` prop will be called when a header is clicked with the argument: ``` {[accessor]: 'ascending'|'descending'|'none'} ```.

To enable row selection. Set the `selectRows` prop to `true`. This will render a CheckBox column and any function passed to `OnRowSelectionChanged` will be called with the selected row details. You can set the label for this header using the `selectHeaderLabel` prop. If you want to disable selection for individual rows, include the optional `disableSelect` key in that particular row's rowData object like so:

```
[
  {
    id: 0,
    accessor1: 'value',
    accessor2: 'another value',
    disableSelect: true,
  }
 ]
```

This will cause that row's checkbox to render with disabled styling and the user will be unable to select it.

NOTE: For a complete table client side example please check the `PagingToolbar` component docs.
*/


function Table(_ref10) {
  var _ref10$rowData = _ref10.rowData,
      rowData = _ref10$rowData === void 0 ? [] : _ref10$rowData,
      _ref10$columns = _ref10.columns,
      columns = _ref10$columns === void 0 ? [] : _ref10$columns,
      _ref10$selectedIds = _ref10.selectedIds,
      selectedIds = _ref10$selectedIds === void 0 ? [] : _ref10$selectedIds,
      _ref10$selectHeaderLa = _ref10.selectHeaderLabel,
      selectHeaderLabel = _ref10$selectHeaderLa === void 0 ? '' : _ref10$selectHeaderLa,
      _ref10$selectRows = _ref10.selectRows,
      selectRows = _ref10$selectRows === void 0 ? false : _ref10$selectRows,
      _ref10$sortColumns = _ref10.sortColumns,
      sortColumns = _ref10$sortColumns === void 0 ? false : _ref10$sortColumns,
      _ref10$tableLayout = _ref10.tableLayout,
      tableLayout = _ref10$tableLayout === void 0 ? 'fixed' : _ref10$tableLayout,
      _ref10$onHeaderClick = _ref10.onHeaderClick,
      onHeaderClick = _ref10$onHeaderClick === void 0 ? function () {} : _ref10$onHeaderClick,
      _ref10$onSelectHeader = _ref10.onSelectHeaderClick,
      onSelectHeaderClick = _ref10$onSelectHeader === void 0 ? function () {} : _ref10$onSelectHeader,
      _ref10$onRowSelection = _ref10.onRowSelectionChange,
      onRowSelectionChange = _ref10$onRowSelection === void 0 ? function () {} : _ref10$onRowSelection;
  var defaultSort = findDefaultSort(columns);

  var _React$useState3 = _react["default"].useState(defaultSort),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      headerSortOptions = _React$useState4[0],
      setHeaderSortOptions = _React$useState4[1];

  function handleSelectHeaderClick() {
    onSelectHeaderClick();
  }

  function handleHeaderClick(accessor, sortEnabled) {
    if (!sortEnabled) return;
    var newSortHeaderObj = getNextSortHeaderObj(accessor, headerSortOptions[accessor], defaultSort);
    setHeaderSortOptions(newSortHeaderObj);
    onHeaderClick(newSortHeaderObj);
  }

  function handleSelectableRowClick(event) {
    var value = event.target.value;
    onRowSelectionChange({
      id: value,
      selected: !selectedIds.includes(value)
    });
  }

  return /*#__PURE__*/_react["default"].createElement(StyledTable, {
    tableLayout: tableLayout
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement(TableHeader, {
    columns: columns,
    sortColumns: sortColumns,
    sortOptions: headerSortOptions,
    selectRows: selectRows,
    selectHeaderLabel: selectHeaderLabel,
    onClick: handleHeaderClick,
    onSelectHeaderClick: handleSelectHeaderClick
  })), /*#__PURE__*/_react["default"].createElement("tbody", null, rowData.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement(TableRow, {
      key: "row-".concat(row.id),
      row: row,
      columns: columns,
      selectRows: selectRows,
      selected: selectedIds.includes(row.id),
      onChange: handleSelectableRowClick
    });
  })));
}